import { render, staticRenderFns } from "./AccountVerifyView.vue?vue&type=template&id=0cc70088&scoped=true&lang=pug"
import script from "./AccountVerifyView.vue?vue&type=script&lang=ts"
export * from "./AccountVerifyView.vue?vue&type=script&lang=ts"
import style0 from "./AccountVerifyView.vue?vue&type=style&index=0&id=0cc70088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc70088",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VTextField})
